"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { FlaskConical, BookOpen, FileText, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "@/components/ui/command";
const searchItems = [{
  id: "1",
  group: "AI Verktøy",
  title: "Automatisert Prospektgenerering",
  icon: "flask"
}, {
  id: "2",
  group: "AI Verktøy",
  title: "Smart Kundeoppfølging (CRM)",
  icon: "book"
}, {
  id: "3",
  group: "Dokumentasjon",
  title: "Effektivitetsanalyse for Meglere",
  icon: "file"
}, {
  id: "4",
  group: "Dokumentasjon",
  title: "Integrasjonsguide for Eiendomssystemer",
  icon: "file"
}, {
  id: "5",
  group: "Teknisk Innsikt",
  title: "Sikkerhet og Personvern i AI",
  icon: "file"
}, {
  id: "6",
  group: "Teknisk Innsikt",
  title: "Prediktiv Prisanalyse Modeller",
  icon: "flask"
}];
const iconMap: Record<string, React.ElementType> = {
  flask: FlaskConical,
  book: BookOpen,
  file: FileText
};
export default function ResearcherResourceCenter() {
  const groups = Array.from(new Set(searchItems.map(item => item.group)));
  return <section data-section-id="223195" id="fremtidens-eiendomsmegling" className="bg-background text-foreground relative min-h-[80vh] flex flex-col items-center justify-center py-24 px-4 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] opacity-10 [mask-image:radial-gradient(ellipse_80%_60%_at_50%_40%,#000_40%,transparent_100%)]" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center space-y-8">
        <div className="space-y-4 max-w-3xl flex flex-col items-center">
          <Link to="/" className="mb-2">
            <img src="https://social-wallaby.10web.cloud/wp-content/uploads/2026/04/LOGO.png" alt="Xora Logo" className="h-150 w-auto" />
          </Link>
          <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground drop-shadow-lg">
            Fremtidens <br className="hidden md:block" />
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">Automatisering</span>
          </h1>
          <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">Xora revolusjonerer hverdagen for eiendomsmeglere med intelligent <br /><strong>AI-automatisering.</strong></p>
        </div>

        <div className="w-full max-w-2xl relative mt-8">
          {}
          
          
          <div className="relative bg-card/40 backdrop-blur-2xl border border-white/10 rounded-xl shadow-2xl shadow-black/60 overflow-hidden !bg-[url(https://social-wallaby.10web.cloud/wp-content/uploads/2026/04/LOGO.png)] !bg-[url(https://social-wallaby.10web.cloud/wp-content/uploads/2026/04/LOGO.png)]">
            <SafeHydrate><Command className="bg-transparent" shouldFilter={false}>
              
              
            </Command></SafeHydrate>
          </div>
        </div>
      </div>
    </section>;
}